import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { clearAll } from 'src/redux/registrant';
import vw from 'src/styles/utils';
import Helmet from 'react-helmet';
import FormHeader from '../../components/FormHeader/FormHeader';
import ArrowButton from 'components/ArrowButton';

const LegalThankYou = () => {
  const dispatch = useDispatch();

  dispatch(clearAll());
  return (
    <>
      <Helmet
        meta={[
          {
            name: 'robots',
            content: 'noindex,nofollow',
          },
        ]}
      />
      <FormHeader />

      <Root>
        {/* <Logo src={require('src/assets/images/logo.svg')} alt="logo" /> */}

        <Title>
          <h1>Thank You for Submitting Your Lawyer / Notary.</h1>

          <h2 className="strapline">
            We have successfully received your information.
          </h2>

          <nav>
            <ArrowButton text="Start Over" to="/legal-representative-form" />
          </nav>
        </Title>
      </Root>
    </>
  );
};

const Root = styled.main`
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 174)}
  ${vw('padding-bottom', 50, 75, 100)}
  background-color: ${(props) => props.theme.color.white};

  nav {
    ${vw('margin-top', 25, 30)}
  }

  h1 {
    ${vw('padding-bottom', 10, 75, 20)}
  }
  h2 {
    ${vw('padding-bottom', 10, 75, 30)}
  }
`;

const Title = styled.div`
  ${vw('padding-top', 11, 200)}
`;

export default LegalThankYou;
